import type {FunctionComponent} from 'react'
import {type getTranslation} from '~/localization/translation'
import {BrgIconPersonWithPaperPlane} from '~/icons/about-us-page/brg-icon-person-with-paper-plane'
import {BrgIconStars} from '~/icons/about-us-page/brg-icon-stars'
import {BrgIconSuperHeroWithStars} from '~/icons/about-us-page/brg-icon-superhero-with-stars'

interface AboutPageLegacyProps {
  translations: ReturnType<typeof getTranslation>
  siteName: string
  contactEmail: string
  hostname: string
}
export const AboutPageLegacy: FunctionComponent<AboutPageLegacyProps> = ({
  translations,
  siteName,
  contactEmail,
  hostname,
}) => {
  return (
    <div className="flex flex-col items-center text-[#363636] mobile:px-4">
      <section className="flex max-w-[1040px] flex-col items-center bg-white pb-10 pt-12">
        <h3 className="text-back pb-8 text-base font-medium">{translations.About.title}</h3>
        <h1 className="px-[38px] pb-8 text-center text-5xl font-semibold tablet:text-[32px] mobile:hidden">
          {translations.About.mainHeadingDesktop}
        </h1>
        <h1 className="hidden px-[38px] pb-8 text-center text-5xl font-semibold tablet:text-[32px] mobile:block">
          {translations.About.mainHeadingMobile}
        </h1>
        <div className="mb-12 h-1 w-[140px] bg-[#F0C52B] tablet:mb-10" />
        <p className="text-center text-2xl mobile:hidden">{translations.About.bodyTextDesktop(siteName)}</p>
        <p className="hidden text-center text-2xl mobile:block">{translations.About.bodyTextMobile(siteName)}</p>
      </section>
      <section className="tablet:pb-18 flex w-full flex-col items-center bg-[#F8F8F8] pb-20 pt-10">
        <h1 className="pb-4 text-5xl font-semibold tablet:text-[32px]">{translations.About.statsHeading}</h1>
        <h2 className="pb-12 text-[32px] font-medium tablet:text-2xl">{translations.About.statsSubheading}</h2>
        <section className="relative mb-20 grid grid-cols-2 grid-rows-2 gap-px rounded-lg bg-white desktop:shadow-xl tablet:mb-10 tablet:grid-cols-1 tablet:gap-4 tablet:bg-transparent">
          <BrgIconSuperHeroWithStars className="absolute -left-[200px] bottom-0 tablet:bottom-[350px] tablet:left-[-96px] tablet:z-20" />
          <div className="z-10 flex h-[260px] w-[260px] flex-col items-center justify-center bg-white tablet:rounded-lg tablet:shadow-aboutStats">
            <h3 className="text-[32px] font-bold">{translations.About.stats1Value}</h3>
            <div className="my-4 hidden h-[1px] w-[148px] bg-gradient-to-r from-white via-yellow-400 to-white mobile:block" />
            <p
              className="break-words text-center text-lg"
              dangerouslySetInnerHTML={{__html: translations.About.stats1Title}}
            />
          </div>
          <div className="z-10 flex h-[260px] w-[260px] flex-col items-center justify-center bg-white tablet:rounded-lg tablet:shadow-aboutStats">
            <h3 className="text-[32px] font-bold">{translations.About.stats2Value}</h3>
            <div className="my-4 hidden h-[1px] w-[148px] bg-gradient-to-r from-white via-yellow-400 to-white mobile:block" />
            <p
              className="break-words text-center text-lg"
              dangerouslySetInnerHTML={{__html: translations.About.stats2Title}}
            />
          </div>
          <div className="z-10 flex h-[260px] w-[260px] flex-col items-center justify-center bg-white tablet:rounded-lg tablet:shadow-aboutStats">
            <h3 className="text-[32px] font-bold">{translations.About.stats3Value}</h3>
            <div className="my-4 hidden h-[1px] w-[148px] bg-gradient-to-r from-white via-yellow-400 to-white mobile:block" />
            <p
              className="break-words text-center text-lg"
              dangerouslySetInnerHTML={{__html: translations.About.stats3Title}}
            />
          </div>
          <div className="z-10 flex h-[260px] w-[260px] flex-col items-center justify-center bg-white tablet:rounded-lg tablet:shadow-aboutStats">
            <h3 className="text-[32px] font-bold">{translations.About.stats4Value}</h3>
            <div className="my-4 hidden h-[1px] w-[148px] bg-gradient-to-r from-white via-yellow-400 to-white mobile:block" />
            <p
              className="break-words text-center text-lg"
              dangerouslySetInnerHTML={{__html: translations.About.stats4Title}}
            />
          </div>
          <BrgIconStars className="absolute -bottom-[75px] -right-[60px] tablet:bottom-[132px] tablet:right-[-18px] tablet:z-20" />
          <div className="z-9 absolute bottom-0 left-0 h-full w-full bg-white-to-yellow bg-blend-lighten tablet:hidden" />
        </section>
        <p className="text-center text-2xl text-black tablet:text-base">{translations.About.statsBottomText}</p>
      </section>
      <section className="relative flex flex-col items-center bg-white py-20 tablet:pb-12 tablet:pt-[270px]">
        <h3 className="mb-10 text-center text-2xl font-semibold">{translations.About.contactHeading}</h3>
        <BrgIconPersonWithPaperPlane className="mb-10 tablet:absolute tablet:top-[-55px]" />
        <p className="mb-10 max-w-[830px] text-center text-base">{translations.About.contactText(hostname)}</p>
        <a href={`mailto:${contactEmail}`} className="rounded-full bg-[#363636] px-4 py-[10px] text-base text-white">
          {translations.About.ctaText}
        </a>
      </section>
    </div>
  )
}
